import React, { useState } from 'react';
import {
  Button,
  InputAdornment,
  keyframes,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from '@mui/material';
import huFlag from '../../assets/hungary-flag-icon.png';
import PublicIcon from '@mui/icons-material/Public';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../globalStore/store';
import { setFirstName, setLastName, setPhone } from '../../reducers/user/userSlice';

interface RegistrationStep2Props {
  handleNextStep: () => void;
}

const RegistrationStep2: React.FC<RegistrationStep2Props> = ({ handleNextStep }) => {
  const phone: string = useSelector((state: RootState) => state.user.phone);
  const [selectedIcon, setSelectedIcon] = useState<string>('flag');
  const lastName: string = useSelector((state: RootState) => state.user.lastName);
  const firstName: string = useSelector((state: RootState) => state.user.firstName);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const dispatch = useDispatch();

  const handleIconChange = (event: SelectChangeEvent) => {
    setSelectedIcon(event.target.value as string);
    if (event.target.value === 'flag') {
      dispatch(setPhone('+36'));
    } else {
      dispatch(setPhone(''));
    }
  };

  const validateFields = () => {
    const newErrors: { [key: string]: string } = {};
    if (!lastName) newErrors.lastName = 'Vezetéknév megadása kötelező';
    if (!firstName) newErrors.firstName = 'Keresztnév megadása kötelező';
    if (!phone) {
      newErrors.phone = 'Telefonszám megadása kötelező';
    } else if (selectedIcon === 'flag' && !phone.startsWith('+36')) {
      newErrors.phone = 'A telefonszám formátuma nem megfelelő pl.: +36301234567';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateFields()) {
      handleNextStep();
    }
  };

  const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

  return (
    <>
      <Typography variant={'body2'} textAlign={"center"}>{"Kezdésnek add meg az elérhetőségeidet, hogy mielőbb hozzáférj a személyre szabott profilodhoz."}</Typography>
      <TextField
        fullWidth
        name={'lastName'}
        type="text"
        label={'Vezetéknév'}
        value={lastName}
        onChange={(e) => dispatch(setLastName(e.target.value))}
        error={!!errors.lastName}
        helperText={errors.lastName}
      />
      <TextField
        fullWidth
        name={'firstName'}
        type="text"
        label={'Keresztnév'}
        value={firstName}
        onChange={(e) => dispatch(setFirstName(e.target.value))}
        error={!!errors.firstName}
        helperText={errors.firstName}
      />
      <TextField
        fullWidth
        name={'phone'}
        type="tel"
        label={'Telefonszám'}
        value={phone}
        onChange={(e) => dispatch(setPhone(e.target.value))}
        error={!!errors.phone}
        helperText={errors.phone}
        InputProps={{
          startAdornment: (
            <InputAdornment position={'start'}>
              <Select
                variant={'standard'}
                value={selectedIcon}
                onChange={handleIconChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
              >
                <MenuItem value={'flag'}>
                  <img src={huFlag} alt={'huFlag'} style={{ width: '20px', margin: 'auto' }} />
                </MenuItem>
                <MenuItem value={'alternate'}>
                  <PublicIcon sx={{ color: '#ec62b0', animation: `${spin} 12s linear infinite` }} />
                </MenuItem>
              </Select>
            </InputAdornment>
          )
        }}
      />
      <Button variant={'contained'} color={'primary'} onClick={handleNext}>{'Tovább a PIN kód beállításához'}</Button>
    </>
  );
};

export default RegistrationStep2;